<template>
  <b-navbar-nav class="cx_listViewMenuBar">
    <slot name="main_head"/>
    <ListViewMenu v-if="edit && $api.spMode == false" :enabled ="listView.selected != null" svg="icon_tool_edit" title="詳細表示" @click="listView.onOpenDialog" sc="F1" :event="false" />    
    <!-- <ListViewMenu v-if="edit && $api.spMode == false" :enabled ="listView.selected != null && listView.editorVisible" svg="icon_tool_edit" title="list_menu_edit" @click="listView.onEdit" :perm="listView.perm != null && listView.fullSizeEditor == false ? listView.perm + '.edit' : ''" sc="F1" :event="false" /> -->
    <ListViewMenu v-if="add" svg="icon_tool_new" title="list_menu_add" @click="listView.onAdd" :perm="listView.perm ? listView.perm + '.add' : ''" sc="F2" :event="false" />
    <ListViewMenu v-if="copy" :enabled ="listView.selected != null" svg="icon_tool_copy" title="list_menu_copy" @click="listView.onCopy" :perm="listView.perm ? listView.perm + '.copy' : ''" :event="false" />
    <ListViewMenu v-if="del" svg="icon_tool_delete"  title="list_menu_delete" @click="listView.onDelete" :perm="listView.perm ? listView.perm + '.delete' : ''" :event="false" />
    <ListViewMenu v-if="isStateObject" svg="send_black"  title="ワークフロー" @click="showWorkflowDialg" :perm="listView.perm + '.approve'" :event="false" />    

    <slot name="main"></slot>     
    <b-nav-item-dropdown class="cx_card_list_menu_item" left v-if="$scopedSlots.default" :disabled="$api.perms.hasMenuPermission(listView.perm ? listView.perm + '.process': '') == false"  @show="setPosition">
      <template slot="button-content">
      <!-- <i class="material-icons small valign">loop</i> -->
      <SvgIcon name="icon_tool_disposal" :width="18" :height="18"/>
       業務処理
      </template>
      <slot></slot>      
    </b-nav-item-dropdown>
    <!-- メール送信 -->
    <b-nav-item-dropdown class="cx_card_list_menu_item" v-if="isShowMail" left  :disabled="$api.perms.hasMenuPermission(listView.perm + '.process') == false" @show="setPosition" @hook:mounted="onMenuMounted($refs.mail_menu, `選択した伝票の取引先すべてに、一括で帳票を送信します。※取引先のメールアドレスの設定が必要です。<br>設定方法は<a href='https://support.s-flow.net/ja/articles/8259489-帳票をメールで送信する方法と事前設定' target='_blank'>こちら</a>`)">
      <template slot="button-content"><span ref="mail_menu"><SvgIcon name="attach_email_black" :width="18" :height="18"/>メール送信</span></template>
      <!-- <b-dropdown-item v-for="(template, index) in mailReports" :key="index" @click="onReportSend(index)">{{ template.reportName }}</b-dropdown-item> -->
      <ListViewMenu v-for="(template, index) in mailReports" :key="index" @click="onReportSend(index)" :title="template.reportName " :event="false"/>
      <div class="cx_listview_menu_splitter" v-if="$scopedSlots.mail" />
      <slot name="mail"></slot>
    </b-nav-item-dropdown>

    <b-nav-item-dropdown class="cx_card_list_menu_item" v-if="reports.length > 0" left @show="setPosition">
      <template slot="button-content">
        <!-- <i class="material-icons small valign">list_alt</i> -->
        <SvgIcon name="icon_tool_report" :width="18" :height="18"/>
        帳票
      </template>
      <!-- <b-dropdown-item v-for="(template, index) in reports" :key="index" @click="onReportGenerate(index)">{{ template.reportName }}</b-dropdown-item> -->
      <ListViewMenu v-for="(template, index) in reports" :key="index" @click="onReportGenerate(index)" :title="template.reportName" :event="false"/>
      <div class="cx_listview_menu_splitter" v-if="$scopedSlots.report"></div>
      <slot name="report"></slot>       
    </b-nav-item-dropdown>
    <b-nav-item-dropdown class="cx_card_list_menu_item" left v-if="listView.exportQuery != null || listView.importQuery != null" @show="setPosition">
      <template slot="button-content">
        <!-- <i class="material-icons small valign">cloud_done</i>  -->
        <SvgIcon name="icon_tool_file" :width="18" :height="18"/>        
      ファイル</template>
      <ListViewMenu v-if="listView.exportQuery != null"  icon="cloud_download" title="エクスポート" @click="onExport(null)" :perm="listView.perm" tooltip="検索結果をエクセルにエクスポートします。" :event="false" />
      <ListViewMenu v-for="(layout, index) in exportLayouts" :key="index"   icon="cloud_download" :title="'エクスポート(' + layout.layoutName + ')'" @click="onExport(layout.id)" :event="false" />      
      <slot name="export"></slot>      
      <ListViewMenu v-if="listView.importQuery != null" icon="cloud_upload" title="インポート" @click="listView.onImport(null)" :perm="listView.perm ? listView.perm + '.import' : ''"  :event="false" />
      <ListViewMenu v-for="(layout, index) in importLayouts" :key="index + 100"   icon="cloud_upload" :title="'インポート(' + layout.layoutName + ')'" @click="listView.onImport(layout.id)" :perm="listView.perm ? listView.perm + '.import' : ''" :event="false" />            
      <slot name="import"></slot>      
      <slot name="file_layout_download"></slot>
      <div class="cx_listview_menu_splitter" v-if="voucherImportQuery" />  
      <ListViewMenu v-if="voucherImportQuery"  icon="note_add" @click="onVoucherImport" title="伝票インポート" :event="false"/>          
    </b-nav-item-dropdown>
    <div class="cx_listView_tour" id="notification">
      <HelpContent :tag="listView.title" :left="true"/>                       
    </div>

    <!-- <ListViewMenu v-if="favorite" icon="favorite" title="list_menu_favorite" @click="listView.onFavorite" /> -->
    <!-- 得意先指定帳票メール送信未指定分選択 -->
    <b-modal class="dialog" v-model="isShowSelectDesignationReportSending" centered title="得意先指定帳票未指定分の選択" @ok="onDesignationReportSend" :no-close-on-backdrop="true">
      <Label fontWeight="300">未指定分の帳票を選択してください</Label>
      <AutoComplete title="指定帳票未指定分" :value.sync="designationReportUnspecifiedId"  ref="designationReportUnspecifiedId" :provider="getReportTemplates" :required="true" tooltip="送信対象の得意先に指定帳票が設定されていない場合、ここで指定した帳票が送信されます。" />
    </b-modal>
    <!-- 対外帳票の出力方法 -->
    <b-modal class="dialog" v-model="showReportStyle" centered title="帳票の出力形式" @ok="onReportStyleSelected" :no-close-on-backdrop="true" :html="designationReport?'':reportHtml" >
      <Label fontWeight="300">帳票の出力形式を選択してください。</Label>
      <RadioButton title="出力形式" :isEdit="true" :value.sync="onExceFormat" list="reportStyles" v-if="showReportStyle" @update:value="onExcelFormatRadioChanged()"/>
      <CheckBox title="ファイルをまとめる" :isEdit="true" :value.sync="onCollectPdf" list="collectPdf" :enabled="designationReport == false && showReportStyle && checkedMultiple==true && (electronicBookMode==false||onExceFormat==true)"  tooltip="出力される帳票を1ファイルにまとめるか選択行ごと別ファイルにするかを選択できます。"/>
      <CheckBox title="出力先" v-if=" checkedMultiple==false" :isEdit="true" :value.sync="onExportSystemLog" list="exportSystemLog" :enabled="showReportStyle"  tooltip="データ量が多い場合や出力時にエラーが発生する場合はチェックをオンにしてください。システムログの【添付ファイル】タブからファイルをダウンロードできます。"/>
      <AutoComplete title="指定帳票未指定分" :value.sync="designationReportTemplateId"  ref="designationReportTemplate" :provider="getReportTemplates" v-if="showAtcDesignationReportTemplate" :required="true" tooltip="出力対象の得意先に指定帳票が設定されていない場合、ここで指定した帳票が出力されます。" />
    </b-modal>
    <!-- エクスポート方法 -->
    <b-modal class="dialog" v-model="showExportStyle" centered title="エクスポート" @ok="onExportExecute" :no-close-on-backdrop="true">
      <Label fontWeight="300">出力範囲を選択してください。</Label>
      <RadioButton title="出力範囲" :isEdit="true" :value.sync="onlySelectedItems" list="exportRangeFlags" v-if="showExportStyle" />
    </b-modal>    
    <!-- 一括確定処理 -->
    <b-modal class="dialog" v-model="isWorkflowDialogVisible" centered title="一括ワークフロー操作" @ok="executeWorkflow" :no-close-on-backdrop="true" v-if="isWorkflowDialogVisible">
      <Label fontWeight="300">ワークフローアクションを選択してください。</Label>
      <ComboBox title="アクション" :isEdit="true" :value.sync="workflowStateIdTo" :provider="getWorkflowStates" :required="true"  ref="workflowAction" />
      <TextBox title="メッセージ" :isEdit="true" :value.sync="workflowMessage"  :rows="3"/>      
      <div v-if="isShowSendReportSetting">
      <CheckBox title="帳票を送信する" :value.sync="isSendReportMail" list="isSendReportMail"/>
      <AutoComplete ref="atcReportTemplate" title="送信する帳票" :value.sync="templateId" :provider="() => getTemplates(workflowAction)" :enabled="isSendReportMail" :class="{'disabled': !isSendReportMail}" :required="isSendReportMail ? true : false" />
      </div>
      <p class="workflow_dialog_notes">※ワークフロー進行時に帳票メールを送信する際の設定は<a href="https://support.s-flow.net/ja/articles/8259490" target="_blank">こちら</a></p>
    </b-modal>
    <!-- メール内容確認・編集ダイアログ -->
    <b-modal class="cx_mail_info_dialog" v-model="isMailInfoDialogVisible" centered title="メール内容確認" @ok="sendMail" @cancel="cancelMail" :no-close-on-backdrop="true" v-if="isMailInfoDialogVisible" ok-title=" 次へ " cancel-title="閉じる" 
      html="<p class='mail_info_dialog_tips'>※送信元アドレスの変更やCCの設定も可能です。詳しくは <a href='https://support.s-flow.net/ja/articles/8259489#h_8d2b8a5d96' target='_blank'>サポートサイト</a>をご確認ください。</p>">
      <SlideControl :slideItems="emailInfos" >
        <template slot-scope="{currentItem}">
          <AutoComplete v-if="isMultipleReportSend" title="帳票名" :value.sync="currentItem.reportTemplate" query="ReportTemplateMasterQuery" :enabled="false" :isLink="true" @linkClicked="onLinkClicked(currentItem.reportTemplate)"/>
          <AutoComplete v-else title="帳票名" :value.sync="reportTemplate" query="ReportTemplateMasterQuery" :enabled="false" :isLink="true" @linkClicked="onLinkClicked(reportTemplate)"/>
          <PopupEditor v-model="showReportTemplateEditor" title="帳票テンプレート" @closing="onReportTemplateEditorClosing" mode="editor" >
            <ReportTemplate v-if="isMultipleReportSend" slot-scope={popup} :popup="popup" :id="currentItem.reportTemplate.id" ref="editor"/>
            <ReportTemplate v-else slot-scope={popup} :popup="popup" :id="reportTemplate ? reportTemplate.id : null" ref="editor"/>
          </PopupEditor>
          <TextBox v-if="currentItem" title="伝票番号" :value="currentItem.voucherNo" :enabled="false" tooltip=""/>
          <AtcCounterpart v-if="currentItem && currentItem.counterpart" title="取引先" :value.sync="currentItem.counterpart"  :enabled="false" @closed="onCounterpartClosed"/>
          <TextBox v-if="currentItem" class="textbox_email_address" title="メールアドレス" :value.sync="currentItem.mailAddress" placeholder="上記取引先をクリックして【担当者メール】を設定するか、ここに直接入力してください" tooltip="取引先マスタの【担当者メール】が表示されます。<br>マスタを編集するには上記取引先をクリックして確定取消した後【担当者メール】にご入力ください。<br>カンマ（,）区切りで複数入力できます。"/>
          <TextBox v-if="currentItem" title="メールタイトル" :value.sync="currentItem.subject" tooltip="帳票テンプレートマスタのメール設定内の【タイトル】が表示されます。<br>マスタを編集するには上記【帳票名】をクリックして【公開取消】した後【メール設定タブ】を編集します。詳しくは<a href='https://support.s-flow.net/ja/articles/8259489#h_872d9fc3ca' target='_blank'>サポートサイト</a>をご確認ください。" />
          <TextBox v-if="currentItem" title="メール本文" :value.sync="currentItem.body" rows="10" tooltip="帳票テンプレートマスタのメール設定内の【メール文面】が表示されます。<br>マスタを編集するには上記【帳票名】をクリックして【公開取消】した後【メール設定タブ】を編集します。詳しくは<a href='https://support.s-flow.net/ja/articles/8259489#h_872d9fc3ca' target='_blank'>サポートサイト</a>をご確認ください。" />
        </template>
      </SlideControl>
    </b-modal>
    <!-- 伝票インポート画面 -->
    <b-modal v-model="showVoucherImport" title="伝票インポート(複数可)" @ok="onVoucherImportExecute" :no-close-on-backdrop="true" centered v-if="showVoucherImport">
      <div class="cx_dialog_import">
        <input type="file" id="filename" name="files" ref="file" size="100" multiple/>
      <div class="spacer">&nbsp;</div>
      <TextBox title="シート名" :value.sync="voucherImportQuery.targetSheet" :required="true" ref="sheetName" />
      </div>
    </b-modal>    
  </b-navbar-nav>
</template>
<script lang="ts">
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import * as Components from '@/agiles/components';
import * as Common from '@/agiles/common';
import { FileLayoutQuery, ObjectBase } from '../../tenant/common';


@Component
export default class ListViewMenuBar extends Vue {
  @Prop() public listView: Components.ListView;
  @Prop({default:true}) public edit:boolean;
  @Prop({default:true}) public add:boolean;
  @Prop({default:true}) public copy:boolean;
  @Prop({default:true}) public del:boolean;
  @Prop({default:true}) public favorite:boolean;
  @Prop({default:true}) public workflow:boolean;
  @Prop({ default: false }) public electronicBookMode: boolean;
  @Prop({ default: null }) public reportHtml?: string;
  @Prop({ default: null }) public getKeyValue: (item: any) => string;
  @Prop({ default: null }) public voucherImportQuery:Common.VoucherImportQuery;

  public exportLayouts: Common.FileLayout[] = new Array();
  public importLayouts: Common.FileLayout[] = new Array();  

  public reports: Array<Common.ReportTemplate> = new Array();
  public mailReports: Array<Common.ReportTemplate> = new Array();
  public isShowMail: boolean = false;
  public created() {
    if (this.listView.title) {

      //パフォーマンスの観点からクエリを統合
      var query = new Common.ListViewMenuQuery();
      query.viewName = this.listView.title;
      this.$api.execute(query).then(response =>{
          var result = response as Common.ListViewMenuResult;
          this.reports = result.reportTemplates;
          this.mailReports = result.reportTemplates.filter(obj => obj.sendMail > 0); // 一覧メニューでの表示制御はテナント設定に委譲
          this.isShowMail = (this.$api.tenantSettings?.enableListMenuMail ?? true) && this.mailReports.length > 0 // 管理サイトにはtenantSettingsがない
          var exportItems = new Array();
          var importItems = new Array();
          result.fileLayouts.forEach(layout=>{
              if ((layout.fileMode & Common.fileLayoutModes.export) != 0) exportItems.push(layout);
              if ((layout.fileMode & Common.fileLayoutModes.import) != 0) importItems.push(layout);           
          });
          this.exportLayouts = exportItems;
          this.importLayouts = importItems;                
      });

      // var query = new Common.ReportTemplateViewQuery();
      // query.viewName = this.listView.title;
      // this.$api.execute(query).then(response => {
      //   this.reports = response.result;
      // });

      // var query2 = new Common.FileLayoutQuery();
      // query2.viewName = this.listView.title;
      // query2.loadMenu = true;
      // this.$api.execute(query2).then(response => {
      //   var exportItems = new Array();
      //   var importItems = new Array();
      //   (response.result as Array<Common.FileLayout>).forEach(layout=>{
      //       if ((layout.fileMode & Common.fileLayoutModes.export) != 0) exportItems.push(layout);
      //       if ((layout.fileMode & Common.fileLayoutModes.import) != 0) importItems.push(layout);           
      //   });
      //   this.exportLayouts = exportItems;
      //   this.importLayouts = importItems;         
      // });
    }
  }

  public onMenuMounted(target: any, tooltip: string){
      this.$api.tooltip.mount(this, target as Element,tooltip);          
  }
  public onReportGenerate(index: number) {
    var template = this.reports[index];
    this.$api.issueGA4event(this.$route.path,template.isSystemOwned ? '帳票出力(' + template.reportName + ')' : '帳票出力(ユーザー帳票)'); //GA4イベント
    if (template.componentName) {
      //コンポーネントを動的にロードする
      var ctor = this.$api.getReportNamespace()[template.componentName];
      let clazz = Vue.extend(ctor);
      let instance = new clazz({
        propsData: {
          template: template,
        },
      }).$mount();
      instance.$on('hidden', () => {
        //destroyできない
        instance.$el.parentElement.removeChild(instance.$el);
        instance.$destroy();
      });
      this.$el.appendChild(instance.$el);
    } else {
      //選択行だけを渡す場合もある
      // var query = new Common.ReportQuery(template.queryName, this.listView.params);
      // query.templateId = template.id;
      // this.$api.download(query);

      if (this.listView.selectedItems.length == 0){
        this.$api.modal.show("無効な操作","出力対象の行をチェックしてください",true,null);
      } else {
        this.checkedMultiple = this.listView.selectedItems.length > 1;
        this.onCollectPdf = this.listView.selectedItems.length == 1 ? false : !this.electronicBookMode;
        this.onExportSystemLog = false;
        this.onExceFormat = false;
        this.targetTemplate = template;
        this.showReportStyle = true;
        this.designationReport = false;
        this.designationReportTemplateId = null;
        this.showAtcDesignationReportTemplate = false;
        // var query = new Common.ReportQuery2(template.queryName, this.listView.selectedItems);
        // query.templateId = template.id;
        // this.$api.download(query);    
      }
    }
  }
  public onDesignationReportGenerate() {
      if (this.listView.selectedItems.length == 0){
        this.$api.modal.show("無効な操作","出力対象の行をチェックしてください",true,null);
        return;
      } 
      this.checkedMultiple = this.listView.selectedItems.length > 1;
      this.onCollectPdf = false;
      this.onExportSystemLog = false;
      this.onExceFormat = false;
      this.showReportStyle = true;
      this.designationReport = true;
      this.designationReportTemplateId = null;
      this.showAtcDesignationReportTemplate = this.listView.selectedItems.filter(obj=>obj.designationReportTemplateId == null || obj.designationReportTemplateId == 0).length > 0;
  }

  public showReportStyle:boolean = false;
  public onExceFormat: boolean = false;
  public checkedMultiple: boolean = false;
  public onCollectPdf: boolean = false;
  public onExportSystemLog: boolean = false;
  public targetTemplate: Common.ReportTemplate;

  public designationReport: boolean = false;  // 得意先指定帳票
  public showAtcDesignationReportTemplate: boolean = false; // 指定帳票未設定あり
  public designationReportTemplateId: number = null;

  public onReportStyleSelected(event: any){
    if (!this.$refs.designationReportTemplate || (this.$refs.designationReportTemplate as Components.AutoComplete).validator.validate()){
      this.showReportStyle = false;
      var template = this.targetTemplate;

      if(this.designationReport == true){
        this.designationReport = false;
        const designationReportTemplate = this.reports.filter(obj=>obj.id == this.designationReportTemplateId)[0];
        const itemLength = this.listView.selectedItems.length;
        const asyncInForLoop = async () => {
          for (let i = 0; i < itemLength; i++) {
            var template = this.reports.filter(obj=>obj.id == this.listView.selectedItems[i].designationReportTemplateId)[0];
            if(!template) template = designationReportTemplate;
            var items = new Array();
            items.push(this.listView.selectedItems[i]);
            var query = new Common.ReportQuery2(template.queryName, items);
            query.templateId = template.id;
            query.onExcelFormat = this.onExceFormat;
            query.onExportSystemLog = this.onExportSystemLog;
            await this.$api.download(query);
          }
        }
        asyncInForLoop();
      }
      else if(this.onCollectPdf == false){
        const itemLength = this.listView.selectedItems.length;
        const asyncInForLoop = async () => {
          for (let i = 0; i < itemLength; i++) {
            var items = new Array();
            items.push(this.listView.selectedItems[i]);
            var query = new Common.ReportQuery2(template.queryName, items);
            query.templateId = template.id;
            query.onExcelFormat = this.onExceFormat;
            query.onExportSystemLog = this.onExportSystemLog;
            await this.$api.download(query);
          }
        }
        asyncInForLoop();
      }else{
        var query = new Common.ReportQuery2(template.queryName, this.listView.selectedItems);
        query.templateId = template.id;
        query.onExcelFormat = this.onExceFormat;
        query.onExportSystemLog = this.onExportSystemLog;
        this.$api.download(query);    
      }
    }else{
      event.preventDefault();
      return;
    }
  }
  public onExcelFormatRadioChanged(){
    // 電子帳簿保存法対応時、PDF出力する場合は個別のみ
    if(this.onExceFormat == false && this.electronicBookMode == true)  this.onCollectPdf = false;
  }
  //***** エクスポート処理 ******  
  public exportLayoutId: number = null;
  public showExportStyle:boolean = false;
  public onlySelectedItems:boolean = true;
  public onExport(layoutId:number){
    this.onlySelectedItems = true;
    this.exportLayoutId = layoutId;
    this.showExportStyle = true;
  }  

  public onExportExecute(){
    this.showExportStyle = false;
    this.listView.onExport(this.exportLayoutId,this.onlySelectedItems);
  }

  //***** 得意先指定帳票メール送信前準備 ******
  public isShowSelectDesignationReportSending: boolean = false;
  public isMultipleReportSend: boolean = false;
  public designationReportUnspecifiedId: number = null;

  public beforeDesignationReportSend(): void {
    if (this.listView.selectedItems.length == 0) {
        this.$api.modal.show("無効な操作","送信対象の伝票をチェックしてください",true,null);
        return;
    }
    this.$api.issueGA4trackevent(this.$route.path, '得意先指定帳票メール送信：開始');
    this.designationReportUnspecifiedId = null;
    this.reportTemplate = null;
    this.isShowSelectDesignationReportSending = this.listView.selectedItems.filter(item => {
        //メール送信可能でない帳票が指定されている場合、nullを入れる（mailReportsには既に送信可の帳票のみが抽出されている）
        if (!this.mailReports.some(report => report.id == item.designationReportTemplateId)) item.designationReportTemplateId = null;
        return item.designationReportTemplateId == null;
      }).length > 0;
    if (!this.isShowSelectDesignationReportSending) this.onDesignationReportSend(event);
  }

  public async onDesignationReportSend(event: any) {
    if (this.isShowSelectDesignationReportSending && !(this.$refs.designationReportUnspecifiedId as Components.AutoComplete).validator.validate()) {
      event.preventDefault();
      return;
    } 
    this.isShowSelectDesignationReportSending = false;
    // StateObjectにEmailInfoが定義されていることを利用してtemplateIdに伝票ごとの帳票idをセットする
    this.listView.selectedItems.forEach(item => {
      let emailInfo: Common.EmailInfo = new Common.EmailInfo();
      if (item.designationReportTemplateId) {
        emailInfo.templateId = item.designationReportTemplateId;
        item.emailInfo = emailInfo;
      } else {
        emailInfo.templateId = this.designationReportUnspecifiedId;
        item.emailInfo = emailInfo;
      }
    });
    // EmailInfoのリスト取得
    this.isMultipleReportSend = true;
    const response = await this.$api.execute(new Common.EmailInfoQuery((this.listView.selectedItems[0] as ObjectBase).className, this.listView.selectedItems, this.mailReports[0].id, this.isMultipleReportSend));
    // ↑this.isMultipleReportSend=trueなので、this.mailReports[0].idは何にも利用されない
    this.emailInfos = response?.result;
    if (this.emailInfos) {
      this.emailInfos.forEach(info => info.reportTemplate = this.mailReports.find(report => report.id == info.templateId)); // infoごとに帳票をセット(揮発性)
    }
    this.isMailInfoDialogVisible = true;
    this.isSendReportMail = false; // GAイベントを正しく集計するため
  }

  public cancelMail() {
    this.isMultipleReportSend = false;
    this.isSendReportMail = false;
    this.designationReportUnspecifiedId = null;
  }

  //***** メール内容確認 ******
  public isMailInfoDialogVisible : boolean = false;
  public emailInfos:any[] = null;
  public reportTemplate:Common.ReportTemplate=null;
  public onReportSend(index: number){
    if (this.listView.selectedItems.length == 0)  {
      this.$api.modal.show("無効な操作","送信対象の伝票をチェックしてください",true,null);
    } else {
      this.reportTemplate = this.mailReports[index];
      this.$api.issueGA4trackevent(this.$route.path, '帳票メール送信：開始');
      this.$api.issueGA4event(this.$route.path,this.reportTemplate.isSystemOwned ? 'メール送信(' + this.reportTemplate.reportName + ')' : 'メール送信(ユーザー帳票)'); //GA4イベント
      // メールデータ読み込み
      this.$api.execute(new Common.EmailInfoQuery((this.listView.selectedItems[0] as ObjectBase).className,this.listView.selectedItems,this.reportTemplate.id)).then(queryResult => {
        let res = queryResult as Common.LoadResult;
        this.emailInfos = res ? res.result : null;
        // (this.$refs.mailInfomation as Components.ListDialog).showDialog();
        this.isMailInfoDialogVisible = true;
        this.isSendReportMail = false; // GAイベントを正しく集計するため
      });
    }
  }

  // 帳票テンプレートのポップアップ編集画面
  public showReportTemplateEditor = false;
  public onLinkClicked(item: Common.ReportTemplate){
    this.showReportTemplateEditor = true;
      // let routeData = this.$router.resolve(String.format('/system/ReportTemplate?id={0}', item.id));
      // window.open(routeData.href, '_blank');          
  }
  // 帳票テンプレートのポップアップ編集画面Close処理
  public onReportTemplateEditorClosing(arg : any){
    const obj = ((this.$refs.editor as Components.ReportTemplate).$refs.mainList as Components.ListView).selected;

    if ((obj as Common.ReportTemplate).state != Common.ApprovalStatus.Approved) {
      arg.canceled = true; // ポップアップ画面が消えないようにするために必要
      this.$api.modal.show('無効な操作','編集画面を閉じる前に公開してください。', true,null);      
      return;
    }
    //メールデータ再読み込み
    this.onCounterpartClosed(obj as Common.ReportTemplate);
  }

  public async onCounterpartClosed(obj: any){
      //メールデータを再読み込みするか確認
      await this.$api.modal.showDialog('メール内容更新', 'マスタの情報をメール内容に反映しますか？', false, 'はい', 'いいえ')
      // メールデータ再読み込み
      this.$api.execute(new Common.EmailInfoQuery((this.listView.selectedItems[0] as ObjectBase).className,this.listView.selectedItems, this.isMultipleReportSend ? this.mailReports[0].id : this.reportTemplate?.id, this.isMultipleReportSend)).then(queryResult => {
        let res = queryResult as Common.LoadResult;
        this.emailInfos = res ? res.result : null;
        if (this.emailInfos && this.isMultipleReportSend) {
          this.emailInfos.forEach(info => info.reportTemplate = this.mailReports.find(report => report.id == info.templateId)); // infoごとに帳票をセット
        }
      });
  }
  //***** メール送信処理 ******
  public async sendMail(event:any){
    let msg = '';
    const numberSending = this.emailInfos.filter(obj => obj.mailAddress).length;
    const numberNotSending = this.emailInfos.length - numberSending;
    if(numberNotSending > 0) {
      if (this.isMultipleReportSend) msg = String.format("得意先指定帳票を添付して、 {0} 件中 {1} 件の取引先に送信します。実行してよろしいですか?", this.emailInfos.length, numberSending);
      else msg = String.format("{0} を添付して、 {1} 件中 {2} 件の取引先に送信します。実行してよろしいですか?",this.reportTemplate?.reportName, this.emailInfos.length, numberSending);
      msg += String.format("\r\n※ {0} 件の取引先にメールアドレスが設定されていません。", numberNotSending);
    }else{
      if (this.isMultipleReportSend) msg = String.format("得意先指定帳票を添付して {0} 件の取引先に送信します。実行してよろしいですか?", numberSending);
      else msg = String.format("{0} を添付して {1} 件の取引先に送信します。実行してよろしいですか?",this.reportTemplate?.reportName, numberSending);
    }
    event.preventDefault();
    await this.$api.modal.showDialog("メール送信",msg,false);
    this.$api.startWaitCusor();
    if (this.isMultipleReportSend) this.$api.issueGA4trackevent(this.$route.path, '得意先指定帳票メール送信：完了');
    else this.$api.issueGA4trackevent(this.$route.path, '帳票メール送信：送信完了'); // GA4イベント
    
    // 50件を超える場合は50件ずつに分割して2回クエリを叩く～LambdaのAsyncペイロード上限は256KB
    if (this.emailInfos.length > 50) {
        const emailInfoFirstHalf = this.emailInfos.slice(0,50);
        const emailInfoSecondHalf = this.emailInfos.slice(50);
        const selectedItemsFirstHalf = this.listView.selectedItems.filter(item => {
          return emailInfoFirstHalf.some(info => info.voucherNo == item.voucherNo);
        });
        const selectedItemsSecondHalf = this.listView.selectedItems.filter(item => {
          return emailInfoSecondHalf.some(info => info.voucherNo == item.voucherNo);
        });

        const resFirst = await this.$api.execute(new Common.ReportSendQuery((this.listView.selectedItems[0] as ObjectBase).className, selectedItemsFirstHalf, this.isMultipleReportSend ? this.mailReports[0].id : this.reportTemplate?.id, emailInfoFirstHalf, this.getKeyValue ? selectedItemsFirstHalf.map(obj=>this.getKeyValue(obj)):null, this.isMultipleReportSend));
        const resSecond = await this.$api.execute(new Common.ReportSendQuery((this.listView.selectedItems[0] as ObjectBase).className, selectedItemsSecondHalf, this.isMultipleReportSend ? this.mailReports[0].id : this.reportTemplate?.id, emailInfoSecondHalf, this.getKeyValue ? selectedItemsSecondHalf.map(obj=>this.getKeyValue(obj)):null, this.isMultipleReportSend));
        
        //システムログへのリンクを表示する
        let links = [new Common.ModalLink(String.format('システムログ ID={0}',resFirst),String.format('/operation/SystemLog?id={0}',resFirst)), new Common.ModalLink(String.format('システムログ ID={0}',resSecond),String.format('/operation/SystemLog?id={0}',resSecond))];
        this.$api.modal.show('処理結果','メール送信処理が開始されました。\r\n送信結果は、通知のメール、または以下のリンクから確認できます。',true,null,links,null,null,
          "<br><p class='cx_dialog_tips'>※ワークフローアクションに帳票を設定することで、自動でメールを送信することが可能になります。　詳細は<a href='https://support.s-flow.net/ja/articles/8259490' target='_blank'>サポートサイト</a>をご確認ください。</p>");
        this.isMailInfoDialogVisible = false;
    } else {
      await this.$api.execute(new Common.ReportSendQuery((this.listView.selectedItems[0] as ObjectBase).className, this.listView.selectedItems, this.isMultipleReportSend ? this.mailReports[0].id : this.reportTemplate?.id, this.emailInfos, this.getKeyValue ? this.listView.selectedItems.map(obj=>this.getKeyValue(obj)):null, this.isMultipleReportSend)).then(res=>{
          //システムログへのリンクを表示する
          var links = [new Common.ModalLink(String.format('システムログ ID={0}',res),String.format('/operation/SystemLog?id={0}',res))];
          this.$api.modal.show('処理結果','メール送信処理が開始されました。\r\n送信結果は、通知のメール、または以下のリンクから確認できます。',true,null,links,null,null,
            "<br><p class='cx_dialog_tips'>※ワークフローアクションに帳票を設定することで、自動でメールを送信することが可能になります。　詳細は<a href='https://support.s-flow.net/ja/articles/8259490' target='_blank'>サポートサイト</a>をご確認ください。</p>");
          this.isMailInfoDialogVisible = false;
        });
    }
    this.isMultipleReportSend = false;
    this.$api.closeWaitCursor();
  }
  


//***** 一括ワークフロー操作 ******

  public isWorkflowDialogVisible : boolean = false;
  public workflowMessage: string = '';
  public workflowStateIdTo:number = null;
  public workflowActions: Common.WorkflowAction[];
  public workflowStates:Common.BindItem[];
  public workflowAction: Common.WorkflowAction;
  public isSendReportMail: boolean = false;
  public templateId: number = null;
  public templateName: string = null;
  public isShowSendReportSetting: boolean = false;

  public get isStateObject() {
    const temp = this.$api.createInstance(this.listView.modelName) ;   
    return this.workflow && (temp instanceof Common.StateObject);
  }
  public getWorkflowStates(){
    return this.workflowStates;
  }
  public showWorkflowDialg(){

    //ワークフロー・状態が同じで所有者に割り当てられていること
    // ダイアログ表示前バリデーション
    if(this.listView.selectedItems.length == 0){
      this.$api.modal.show('無効な操作', '伝票を選択して下さい。', true, null);
      return;
    }        
    var firstItem = this.listView.selectedItems[0] as Common.StateObject;
    if(this.listView.selectedItems.filter(obj => (obj as Common.StateObject).workflowCode != firstItem.workflowCode ||  (obj as Common.StateObject).workflowId != firstItem.workflowId).length > 0){
      this.$api.modal.show('無効な操作', '同じワークフローの伝票を選択してください。', true, null);
      return;
    }
    if(this.listView.selectedItems.filter(obj => (obj as Common.StateObject).workflowStateId != firstItem.workflowStateId).length > 0){
      this.$api.modal.show('無効な操作', '複数の伝票を処理する場合は、「状態」が同じものを選択してください。', true, null);
      return;
    }            
    if(this.listView.selectedItems.filter(obj => this.$api.perms.hasWorkflowPermission((obj as Common.StateObject).workflowHolder) ==false).length > 0){
      this.$api.modal.show('無効な操作', '権限をもつ伝票を選択してください。', true, null);
      return;
    }        
    this.workflowActions = this.$api.perms.getWorkflowActions(firstItem.workflowCode, firstItem.workflowId,firstItem.workflowStateId);
    this.workflowStates =  this.workflowActions.map(obj => new Common.BindItem(obj.stateIdTo,obj.actionName));
    const state = this.$api.perms.getWorkflowState(firstItem.workflowCode, firstItem.workflowId,firstItem.workflowStateId);
    //開始点以外でUserStatusの場合に差戻しボタンを表示する
    if((state.type & Common.StateTypes.EntryStatus) != Common.StateTypes.EntryStatus && (state.type & Common.StateTypes.UserStatus) == Common.StateTypes.UserStatus)
      this.workflowStates.push(new Common.BindItem(-1,'差戻'));

    if(this.workflowStates.length == 0){
      // this.$api.modal.show('無効な操作', '可能なワークフローアクションがありません', true, null);
      this.$api.modal.show('無効な操作',firstItem.messageOnActionMissing, true, null);
      return;
    }       

    this.workflowMessage = '';
    this.workflowStateIdTo = null;
    this.isWorkflowDialogVisible = true;
  }

  @Watch('workflowStateIdTo')
  public setWorkflowAction() {
    this.workflowAction = this.workflowActions.find(action => action.stateIdTo == this.workflowStateIdTo);
    if (this.workflowAction?.isShowSendReport) {
      this.isShowSendReportSetting = true;
      this.templateId = this.workflowAction?.templateId;
      this.isSendReportMail = this.templateId ? true : false;
    }
    else this.isShowSendReportSetting = false;
  }

  public async getTemplates(action: Common.WorkflowAction):Promise<Common.BindItem[]>{
  const workflowControllerName = action.workflow.controller.name;
    let result = this.$api.execute(new Common.WorkflowReportTemplateQuery(workflowControllerName));
    return result;
 }
  public async getReportTemplates():Promise<Common.BindItem[]>{
    return this.atcReportQuery(this.listView.title);
 }
  public async atcReportQuery(viewName:string):Promise<Common.BindItem[]> {
      var bindItems = new Array();
      var query = new Common.ReportTemplateViewQuery();
      query.viewName=viewName;
      await this.$api.execute(query).then(res => {
          var result = res as Common.LoadResult;
          result.result.forEach(obj =>{
            if (this.isShowSelectDesignationReportSending) {
              if (obj.sendMail > 0) bindItems.push(new Common.BindItem(obj.id, obj.name));
            } else {
              bindItems.push(new Common.BindItem(obj.id,obj.name));
            }
          });
        });
      return Promise.resolve(bindItems);
  }

 @Watch('isSendReportMail')
  public setTemplateId() {
    this.templateId = this.isSendReportMail ? this.workflowAction.templateId : null;
  }

  //***** ワークフロー一括操作のメール送信処理 ******
  public async getEmailInfo(){
    // GA4イベント
    this.$api.issueGA4trackevent(this.$route.path, '一括ワークフロー操作メール送信：送信確認');

    // メールデータ読み込み
    await this.$api.execute(new Common.EmailInfoQuery((this.listView.selectedItems[0] as ObjectBase).className, this.listView.selectedItems, this.templateId)).then(queryResult => {
      const res = queryResult as Common.LoadResult;
      this.emailInfos = res ? res.result : null;
    });

    let msg = '';
    if(this.emailInfos.filter(obj=>!obj.mailAddress).length > 0) {
      msg = String.format("{0} を添付して、 {1} 件中 {2} 件の取引先に送信します。実行してよろしいですか?", this.templateName ,this.emailInfos.length,this.emailInfos.filter(obj=>obj.mailAddress).length);
      msg += String.format("\r\n※ {0} 件の取引先にメールアドレスが設定されていません。",this.emailInfos.filter(obj=>!obj.mailAddress).length);
    }else{
      msg = String.format("{0} を添付して {1} 件の取引先に送信します。実行してよろしいですか?", this.templateName, this.emailInfos.filter(obj=>obj.mailAddress).length);
    }
    await this.$api.modal.showDialog("メール送信",msg,false);
    // メール送信処理はsendしてAPIのPostで行う
  }
  
  public async executeWorkflow(event:any){
    //手動バリデーション
    const control = (this.$refs.workflowAction as any) as Components.IControl;
    if (control.validator.validate() == false) {
      event.cancel();
      return;
    }

    // ワークフローアクションでメール送信確認をONにしているか
    if (this.workflowAction.isShowSendReport) {
      // ワークフローメール送信用に帳票名を取得
      this.templateName = (this.$refs.atcReportTemplate as Components.AutoComplete)?.displayName;
      if (this.isSendReportMail && !this.templateId) {
        event.preventDefault();
        await this.$api.modal.show('無効な操作', '※「送信する帳票」が選択されていません。\r\n　「送信する帳票」を選択するか、\r\n　「帳票メールを送信」のチェックを外してください。', true, null);
        return;
      }
      if (!this.isSendReportMail && this.workflowAction.templateId) {
        // GA4イベント
        this.$api.issueGA4trackevent(this.$route.path, '一括ワークフロー操作メール送信：チェック外してフロー進行');
      }
      if (!this.isSendReportMail) this.isWorkflowDialogVisible = false;
    }

　 //事前処理の定義
    var preProcess = (item:Common.StateObject)=>{
      if (this.workflowMessage){
          const msg = new Common.WorkflowMessage();
          msg.userId = this.$api.auth.userId;
          msg.isNote = false;
          msg.destination = ''; //宛先はサーバー側で更新する
          msg.description = this.workflowMessage;
          msg.timeStamp = null; //新規メッセージをマークする
          item.workflowMessage = msg;
      }
      return item;
    }
    //後続処理の定義~ 利用状況照会画面は表示しない
    var postProcess = (item:Common.StateObject,index : number) => {      
      //現在編集中の行は、onWorkflowを呼び出す(追加処理が実装されている場合がある)
      if (index == this.listView.currentId) (this.listView.$parent as any).onWorkflow(index,item);
      else  this.$set(this.listView.items, index, item);
      };

    //stateIdが-1の場合はsendBack
    var lastIndex = this.listView.selectedItems.length -1;
    if (this.workflowStateIdTo == -1) {
      this.listView.selectedItems.reduce(async (previous, obj,index) => {
        await previous;
        var itemIndex = this.listView.items.indexOf(obj); 
        await this.$api.sendBack(preProcess(obj), index== lastIndex).then(obj => postProcess(obj,itemIndex));
      }, undefined);
    }
    else {
      // メール送信準備
      if (this.isSendReportMail) {
        event.preventDefault();
        await this.getEmailInfo();
        this.isWorkflowDialogVisible = false;
        // GA4イベント
        this.$api.issueGA4trackevent(this.$route.path, '一括ワークフロー操作メール送信完了(' + this.templateName +')');
      }
      await this.listView.selectedItems.reduce(async (previous, obj,index) => {
        await previous;
        var itemIndex = this.listView.items.indexOf(obj);
        if (this.isSendReportMail) {
          let emailInfo: Common.EmailInfo = null;
          // 管理サイト対応(PartnerPayment)～emailInfoがnullのままAPIを叩き従来のメール送信処理に進む
          if (obj.className != 'PartnerPayment') emailInfo = await this.emailInfos?.find(info => info.voucherNo == obj.voucherNo);
          if (emailInfo) {
            emailInfo.isSend = this.isSendReportMail;
            emailInfo.templateId = this.templateId;
            obj.emailInfo = emailInfo;
          } 
        } else {
          let emailInfo: Common.EmailInfo = new Common.EmailInfo();
          obj.emailInfo = emailInfo;
        }
        await this.$api.send(preProcess(obj), this.workflowStateIdTo, index== lastIndex).then(obj => postProcess(obj,itemIndex));
      }, undefined);
     
      if (this.isSendReportMail) {
          let links = [new Common.ModalLink('システムログ', '/operation/SystemLog')];
          this.$api.modal.show('処理結果','メール送信処理が開始されました。\r\n送信結果は、通知のメール、または以下のリンクから確認できます。',true,null,links,null,null,
            "<br><p class='cx_dialog_tips'>※ワークフローアクションに帳票を設定することで、自動でメールを送信することが可能になります。　詳細は<a href='https://support.s-flow.net/ja/articles/8259490' target='_blank'>サポートサイト</a>をご確認ください。</p>");
        }
    }
  }
  //***** 一括ワークフロー操作(ここまで) ******  

  
  public setPosition(data: any) {
      var target = data.target as HTMLElement;
      var vue = data.vueTarget as Vue;
      target.setAttribute("style",String.format("left:{0}px;", (vue.$el as any).offsetLeft - vue.$el.parentElement.scrollLeft));

      return data;
    }

  public showVoucherImport:boolean = false;

  public onVoucherImport(){
    this.voucherImportQuery.targetSheet = "入力シート";
    this.showVoucherImport = true;
  }
  public onVoucherImportExecute(){
    if ((this.$refs.sheetName as Components.TextBox).validator.validate() == false) {
      event.preventDefault();
      return;
    }

    const obj = (this.$refs.file as any).files as FileList;
    if (obj.length == 0) {
      this.$api.modal.showDialog('無効な操作','インポートファイルを選択してください',true).then(()=>this.showVoucherImport = true);
      return;
    }
    
    this.$api.upload(this.voucherImportQuery, obj).then(res =>{
      //追加時の処理をコピー(OnSubmit)
      var list = res as Array<any>;
      this.listView.currentId = this.listView.items.length + list.length - 1; //末尾+1
      this.listView.items.push(...list);//onItemsChangedが実行されるので先にcurrentIdを変更する
      (this.listView.$refs.listBox as Components.Grid).resetChecked(); //onItemChanged側で追加を検知できないので手動呼出し
    });
  }
}
</script>
<style lang="scss">
.cx_listViewMenuBar {
  &.navbar-nav{
    flex-direction: row !important; //縦並びは不可
  }
  .cx_spmode & {
    overflow-x: auto;    
  }
  .cx_listview_menu_splitter{
    display: block;
    height: 1px;
    border: 0;
    border-top: 1px solid #ccc;
    box-shadow: 0 1px #fff;    
    margin: 4px 12px;
    padding: 0;
  }
  
  .cx_mail_info_dialog{
    .cx_layer {
      overflow: auto;
    }
    .modal-dialog {
      min-width:800px;
      .cx_spmode & {
        min-width: 60vw;
        margin:0px auto;
        width: 100%;
        justify-content: center;
        .modal-content{
          width: 100%;
        }
      }
      .cx_page_count{
        font-size: 14px;        
      }
      .cx_center_data{
        > .cx_control{
        .cx_control_caption{
          display:block;
          overflow-x: auto;
        }
          span {
            font-size: 14px;
            text-align: left;
          }
        }
      }
      .mail_info_dialog_tips{
        font-size: 14px;
        display: block;
        text-align: left;
      }
      .textbox_email_address {
        ::placeholder {
          color: #ff6347;
        }
      }
    }
  }
  .disabled {
    color: lightgray;
  }
  .dialog {
    .workflow_dialog_notes {
      margin-bottom: 0;
      margin-top: 10px;
      text-align: left;
      font-size: 12px;
    }
  }
}
.cx_dialog_tips{
  font-size: 11px;
  text-align: left;
  margin-left: 40px;
  margin-right: 40px;
  margin-bottom: 0px;
  color: #ff6347;
}
.cx_dialog_html{
  text-align: left;
  font-size: 14px;
  margin-top: 16px;
  margin-bottom: 0;
}
</style>
